export type Gateway = {
  id: string;
  name: string;
  copy: string;
  /** Currency the gateway settles in — shown on the checkout button. */
  settleCurrency: string;
  enabled: boolean;
  /** Optional uploaded icon or poster (data URL). */
  icon?: string;
  /** Public identifier only. Secret keys belong in the backend. */
  publicKey?: string;
  mode: "Live" | "Test";
};

export const gateways: Gateway[] = [
  { id: "bd", name: "BD Payment", copy: "Local wallets and banks", settleCurrency: "BDT", enabled: true, mode: "Live" },
  { id: "card", name: "Visa / Mastercard", copy: "International cards", settleCurrency: "USD", enabled: true, mode: "Test" },
  { id: "binance", name: "Binance Pay", copy: "Binance wallet checkout", settleCurrency: "USD", enabled: true, mode: "Test" },
  { id: "cryptomus", name: "Cryptomus", copy: "Crypto payment processor", settleCurrency: "USD", enabled: true, mode: "Test" },
  { id: "heleket", name: "Heleket", copy: "Alternative crypto checkout", settleCurrency: "USD", enabled: false, mode: "Test" },
  { id: "manual", name: "Manual Payment", copy: "Submit details for review", settleCurrency: "USD", enabled: true, mode: "Live" },
  { id: "lemonsqueezy", name: "Lemon Squeezy", copy: "International card & wallet checkout for digital products", settleCurrency: "USD", enabled: false, mode: "Test" },
];
